// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"799":"0343195de3358988b89e","982":"ab89eb44a80ccf34edb1"}[chunkId] + ".js";
};